<template>
  <div class="hospitals-section">
    <div class="default-modal">
      <el-dialog top="15vh" v-model="exportDialogVisisble" @close="close">
        <div v-loading="exportsLoading">
          <div class="export-dialog-header">
            <div class="export-header-part">
              <h3>ORDERING FACILITIES REPORT</h3>
            </div>

            <el-button
              size="medium"
              class="el-white"
              type="info"
              plain
              @click="close"
            >
              <img src="@/assets/images/icons/cases/close-btn.svg" alt="icon"
            /></el-button>
          </div>
          <div class="selected-string">
            <h3 v-if="selected_search_name">
              Search Name: <span>{{ selected_search_name }}</span>
            </h3>
            <h3 v-if="selected_search_code">
              Search Code: <span>{{ selected_search_code }}</span>
            </h3>
            <h3 v-if="selected_search_fax">
              Search FAX: <span>{{ selected_search_fax }}</span>
            </h3>
            <h3 v-if="selected_search_phone">
              Search Phone: <span>{{ selected_search_phone }}</span>
            </h3>
            <h3 v-if="selected_search_status && selected_search_status.length">
              Selected Status:
              <span>{{ selected_search_status.toString() }}</span>
            </h3>
          </div>
          <div class="export-include-select-field">
            <h4 class="check-all-sub-title">DATA INCLUDES :</h4>

            <el-checkbox
              class="search-checkbox"
              v-model="checkAll"
              @change="handleCheckAllChange"
              >Check All</el-checkbox
            >
          </div>
          <div class="dialog-body">
            <div class="export-popup-body mt-0" v-loading="loading">
              <el-checkbox-group v-model="activeFieldList" @change="isCheckAll">
                <ul class="select-fields-list">
                  <li
                    class="search-checkbox"
                    v-for="(item, index) in exportHospitalsExcelFields"
                    :key="index"
                  >
                    <el-checkbox :label="item.value">
                      {{ item.label }}
                    </el-checkbox>
                  </li>
                </ul>
              </el-checkbox-group>
            </div>
          </div>
          <div class="dialog-footer export-footer w-95">
            <el-button class="cancel-button" @click="close">CANCEL</el-button>
            <el-button class="blue-save-button" @click="downloadHospitals()">
              DOWNLOAD
            </el-button>
          </div>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import UserPermissionsHelper from "@/mixins/UserPermissionsHelper";
import caseDataHelper from "@/mixins/caseDataHelper";
import AppHelper from "@/mixins/AppHelper";
import exportExcelHelper from "@/mixins/exportExcelHelper";

import FilterHelper from "@/mixins/FilterHelper";
import { mapGetters } from "vuex";

export default {
  mixins: [
    UserPermissionsHelper,
    exportExcelHelper,
    caseDataHelper,
    AppHelper,
    FilterHelper,
  ],
  props: [
    "selected_search_phone",
    "selected_search_code",
    "selected_search_name",
    "selected_search_fax",
    "selected_search_status",
  ],
  computed: {
    ...mapGetters("orders", ["getDownloadOrderDataStatus"]),
    ...mapGetters("physicians", ["getAllPhysicians"]),
    ...mapGetters("hospitals", ["getAllHospitals"]),
  },
  data() {
    return {
      exportsLoading: false,
      exportDialogVisisble: true,
      fieldList: [],
      activeFieldList: [],
      checkAll: true,
      loading: false,
      date_type: "collection_date",
      status: "",
    };
  },
  mounted() {
    this.loadFieldsList();
    this.status = this.search_case_status;
  },
  methods: {
    isCheckAll() {
      if (
        this.activeFieldList &&
        this.exportHospitalsExcelFields &&
        this.activeFieldList.length &&
        this.exportHospitalsExcelFields.length &&
        this.activeFieldList.length == this.exportHospitalsExcelFields.length
      ) {
        this.checkAll = true;
      } else {
        this.checkAll = false;
      }
    },
    async downloadHospitals() {
      try {
        if (this.activeFieldList.length) {
          this.exportsLoading = true;
          let params = {
            include: this.activeFieldList,
          };

          if (this.selected_search_phone != "") {
            params.phone = this.selected_search_phone;
          }
          if (this.selected_search_fax != "") {
            params.fax = this.selected_search_fax;
          }
          if (this.selected_search_code != "") {
            params.code = this.selected_search_code;
          }
          if (this.selected_search_name != "") {
            params.name = this.selected_search_name;
          }
          if (
            this.selected_search_status &&
            this.selected_search_status.length
          ) {
            params.status = this.selected_search_status;
          }
          await this.$store.dispatch("hospitals/downloadHospitalData", params);
          this.exportsLoading = false;
          this.close();
        } else {
          this.$message({
            message: "Please select the data fields.",
            type: "warning",
          });
        }
      } catch (err) {
        this.exportsLoading = false;
      }
    },
    loadFieldsList() {
      this.exportHospitalsExcelFields.forEach((obj) => {
        this.fieldList.push(obj.value);
      });
      this.activeFieldList = this.fieldList;
    },
    close() {
      this.$emit("close");
    },
    handleCheckAllChange(val) {
      this.activeFieldList = val ? this.fieldList : [];
    },
  },
};
</script>
<style lang="scss">
.hospitals-section {
  .el-dialog {
    width: 60%;
    @media screen and (min-width: 1600px) {
      width: 50%;
    }
  }
  .select-fields-list {
    @media screen and (min-width: 1600px) {
      grid-template-columns: 1fr 1fr 1fr !important;
    }
  }
}
</style>
